import classnames from 'classnames';
import React from 'react';

const CSS = require('./ModalFooter.module.scss');

interface ModalFooterProps {
  children: any;
  className?: string;
}

function ModalFooter({ children, className, ...rest }: ModalFooterProps) {
  const classes = classnames(CSS.ModalFooter, { [className]: className });

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}

export default ModalFooter;
